<div class="logs">
    <h2 class="logs__title" id="logs-title">Logs</h2>

    <form
        class="logs__form"
        [formGroup]="form"
        (ngSubmit)="download()"
        aria-labelledby="logs-title"
    >
        <mat-form-field>
            <mat-label>Application</mat-label>
            <mat-select formControlName="applicationType">
                @for (type of applicationTypes; track type.value) {
                    <mat-option [value]="type.value">{{ type.label }}</mat-option>
                }
            </mat-select>
        </mat-form-field>

        <mat-form-field>
            <mat-label>From</mat-label>
            <input
                matInput
                [matDatepicker]="fromPicker"
                [max]="today"
                formControlName="from"
            />
            <mat-datepicker-toggle
                matIconSuffix
                [for]="fromPicker"
                aria-label="Open from date picker"
            ></mat-datepicker-toggle>
            <mat-datepicker #fromPicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field>
            <mat-label>To</mat-label>
            <input
                matInput
                [matDatepicker]="toPicker"
                [max]="today"
                formControlName="to"
            />
            <mat-datepicker-toggle
                matIconSuffix
                [for]="toPicker"
                aria-label="Open to date picker"
            ></mat-datepicker-toggle>
            <mat-datepicker #toPicker></mat-datepicker>
        </mat-form-field>

        <button
            mat-flat-button
            color="primary"
            type="submit"
            [disabled]="form.invalid || isDownloading()"
            [attr.aria-busy]="isDownloading() ? 'true' : null"
        >
            @if (isDownloading()) {
                Downloading...
            } @else {
                Download .zip
            }
        </button>
    </form>

    @if (rangeError; as err) {
        <div class="logs__error" role="alert">{{ err }}</div>
    }
</div>
